export function lockScroll() {
  document.body.classList.add('no-scroll');
}

export function unlockScroll() {
  document.body.classList.remove('no-scroll');
}

